<script>
	export let data;
	import { isNewDataChanged } from "../../../../stores/variables";

	let workmodeSample = [
		{
			name: "Понедельник",
			WeekDay: 1,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Вторник",
			WeekDay: 2,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Среда",
			WeekDay: 3,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Четверг",
			WeekDay: 4,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Пятница",
			WeekDay: 5,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Суббота",
			WeekDay: 6,
			StartTime: "00:00",
			EndTime: "00:00",
		},
		{
			name: "Воскресенье",
			WeekDay: 7,
			StartTime: "00:00",
			EndTime: "00:00",
		},
	];
	let loaded;

	const options = {
		mask: "00:00",
	};

	function scheduleOn() {
		data.newData ? (data.newData["Open24"] = "") : (data.switch.value = "");
	}

	function scheduleOff() {
		data.newData
			? (data.newData["Open24"] = "on")
			: (data.switch.value = "on");
	}

	function mask(e) {
		let input = e.target;
		const value = input.value.replace(/\D+/g, "");
		const numberLength = 4;
		let result = "";

		for (let i = 0; i < value.length && i < numberLength; i++) {
			switch (i) {
				case 2:
					result += ":";
					break;
				default:
					break;
			}
			result += value[i];
		}
		input.value = result;
	}

	if (data) {
		if (!data.newData) data.newData = [];

		!data.inputs &&
			(data.inputs = [
				{
					description: "Режим работы текстом",
					field_name: "WorkingHoursComment",
					value: "",
				},
			]);

		!data.switch &&
			(data.switch = {
				field_name: "Open24",
				value: "",
			});

		!data.modes && (data.modes = workmodeSample);
	}
	$: if (data.newData) {
		data.switch.value = data.newData["Open24"];
		data.inputs.forEach((input) => {
			input.value = data.newData[input.field_name];
		});
		if (data.newData.WorkModes && !loaded) {
			data.newData.WorkModes.forEach((new_mode) => {
				let endtime = new_mode.EndTime.split(":");
				let starttime = new_mode.StartTime.split(":");
				new_mode.EndTime = endtime[0] + ":" + endtime[1];
				new_mode.StartTime = starttime[0] + ":" + starttime[1];
			});
			loaded = true;
		}

		if (data.newData.WorkModes) {
			data.modes.forEach((mode) => {
				data.newData.WorkModes.forEach((new_mode) => {
					if (mode.WeekDay == new_mode.WeekDay) {
						mode.StartTime = new_mode.StartTime;
						mode.EndTime = new_mode.EndTime;
					}
				});
			});
		} else {
			data.newData.WorkModes = data.modes;
		}
		if ((data.newData.WorkModes = [])) {
			data.newData.WorkModes = data.modes;
		}
	}
</script>

{#if data}
	{#if data.name}
		<h3>{data.name}</h3>
	{/if}

	<div class="work-mode">
		<div class="work-mode__buttons">
			<button type="button" class:active={5 === 5} on:click={scheduleOn}
				>По расписанию</button
			>
			<button type="button" class:active={5 === 5} on:click={scheduleOff}
				>Круглосуточно</button
			>
		</div>

		{#if !data.switch.value}
			<div class="schedule">
				{#each data.modes as mode, i}
					<div class="schedule__raw">
						<div class="schedule__day">
							<span>{mode.name}</span>
						</div>
						{#if data.newData.WorkModes}
							<div class="schedule__time">
								<input
									style="width: 300px;"
									type="text"
									on:input={(e) => {
										mask(e);
										$isNewDataChanged = true;
									}}
									bind:value={data.newData.WorkModes[i]
										.StartTime}
								/>
								<span>–</span>
								<input
									style="width: 300px;"
									type="text"
									on:input={(e) => {
										mask(e);
										$isNewDataChanged = true;
									}}
									bind:value={data.newData.WorkModes[i]
										.EndTime}
								/>
							</div>
						{:else}
							<div class="schedule__time">
								<input
									placeholder="00:00"
									on:input={() => ($isNewDataChanged = true)}
								/>
								<span>–</span>
								<input
									placeholder="00:00"
									on:input={() => ($isNewDataChanged = true)}
								/>
							</div>
						{/if}
					</div>
				{/each}
			</div>
		{/if}

		{#if data.inputs}
			<div class="work-mode__description">
				{#each data.inputs as input}
					{#if input.field_name}
						<div class="input__wrap input__wrap-comment">
							<input
								type="text"
								on:input={() => ($isNewDataChanged = true)}
								bind:value={data.newData[input.field_name]}
								class="phone__comment"
								maxlength={data.maxlength
									? data.maxlength
									: 400}
							/>
							<span
								class={data.newData[input.field_name]
									? "active"
									: ""}>{input.description}</span
							>
						</div>
						<span>Например, перерыв на обед или особый график</span>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
{/if}

<style lang="scss">
	.schedule {
		display: flex;
		flex-direction: column;
		margin: 24px 0 0 0;
		max-width: 360px;

		&__raw {
			display: flex;
			margin: 0 0 16px 0;
		}
		&__day {
			max-width: 176px;
			display: flex;
			flex-basis: 50%;
			margin-right: 4px;
			align-items: center;
			justify-content: center;
			outline: 0;
			border: 1px solid var(--border-gray-1);
			color: var(--bg-black-1);
			font-size: 16px;
			line-height: 24px;
			border-radius: 8px;
		}

		&__time {
			display: flex;
			color: var(--bg-black-1);
			line-height: 24px;
			font-size: 16px;
			flex-basis: 50%;
			margin-left: 4px;
			flex-grow: 1;
			flex-shrink: 0;

			> input {
				max-width: 75px;
				padding: 9px 0;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 44px;
				outline: 0;
				border: 1px solid var(--border-gray-1);
				color: var(--bg-black-1);
				font-size: 16px;
				line-height: 24px;
				border-radius: 8px;

				&::placeholder {
					color: var(--text-gray-1);
				}

				&:hover,
				&:focus,
				&:focus-within {
					border-color: var(--color-1);
				}
			}

			> span {
				flex-shrink: 0;
				padding: 0 4px;
				line-height: 44px;
			}
		}
	}

	.work-mode {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);

		&__buttons {
			display: flex;
			max-width: 360px;
			> button {
				display: flex;
				align-items: center;
				border-radius: 4px;
				padding: 4px 12px;
				font-size: 13px;
				line-height: 20px;
				flex-basis: 50%;
				justify-content: center;

				background: var(--button-gray-1);
				columns: var(--bg-black-1);
				transition: all 0.2s ease;

				&.active {
					background: var(--bg-black-1-active);
					color: var(--text-main-1);
				}
				&:first-child {
					margin-right: 4px;
				}
				&:last-child {
					margin-left: 4px;
				}
			}
		}

		&__description {
			> span {
				display: flex;
				font-size: 11px;
				line-height: 16px;
				margin: 4px 0 0 16px;
				color: var(--text-gray-1);
			}
		}
	}

	.input__wrap {
		flex-direction: column;
		margin: 24px 0 0 0;
	}
</style>
